(function () {
    'use strict';
    var m = angular.module('profiles');
    m.factory('fileMetaInfoLogic', ["widgetPolling", "fileDao", "metaInfoLogicCore", "modals", "modulesManager", "entityTypes", "troubleshooting", function (widgetPolling, fileDao, metaInfoLogicCore, modals, modulesManager, entityTypes, troubleshooting) {
        return function ($scope, logic) {
            var id = widgetPolling.scope().id;
            var coreOptions = {
                advanced: logic.advanced,
                whiteList: logic.whiteList,
                blackList: logic.blackList,
                autoWidget: true,
                ordering: 'widgetViewOrder',
                entityType: 'file',
                retrieve: function () {
                    return fileDao.retrieve(id);
                }
            };
            if (troubleshooting.entityDebugEnabled() && !!logic.disableEntityDebug) {
                var filterFound = false;
                var filters = _($scope.model.wrapper.filters).map(function (filter) {
                    if (filter.value === 'troubleshooting') {
                        filterFound = true;
                    }
                    return filter;
                });
                if (!filterFound) {
                    filters.push({
                        'type': 'flag',
                        'text': 'Troubleshooting Mode',
                        'value': 'troubleshooting',
                        'local': true
                    });
                    $scope.model.wrapper.filters = filters;
                }
                coreOptions.processParams = function (params) {
                    if (params && params.troubleshooting) {
                        delete coreOptions.whiteList;
                        delete coreOptions.autoWidget;
                        coreOptions.blackList = logic.extendedData || [];
                        coreOptions.rawOutput = true;
                        coreOptions.ordering = 'key';
                    } else {
                        coreOptions.whiteList = logic.whiteList;
                        coreOptions.blackList = logic.blackList;
                        coreOptions.autoWidget = true;
                        coreOptions.ordering = 'widgetViewOrder';
                        delete coreOptions.rawOutput;
                    }
                };
            }
            return metaInfoLogicCore($scope, logic, coreOptions);
        };
    }]);
}());